/**
 * Medical conditions enumeration for patient clinical histories
 */

export const MEDICAL_CONDITIONS = {
  OSTEOPOROSIS: "Osteoporosis",
  PARKINSON: "Parkinson",
  DIABETES: "Diabetes",
  SARCOPENIA: "Sarcopenia",
  SMOKING: "Smoking",
};
